import type { FormEvent, RefObject } from 'react'
import type { Translator } from '../i18n/i18n'

interface SearchPanelProps {
  query: string
  t: Translator
  searching: boolean
  listening: boolean
  voiceAvailable: boolean
  inputRef?: RefObject<HTMLInputElement | null>
  onQueryChange: (value: string) => void
  onSearch: () => void
  onVoice: () => void
}

export function SearchPanel(props: SearchPanelProps) {
  const submit = (event: FormEvent) => {
    event.preventDefault()
    props.onSearch()
  }

  return (
    <section className="search-panel" aria-labelledby="search-heading">
      <div className="eyebrow">V0.1 TECHNICAL SPIKE</div>
      <h1 id="search-heading">{props.t('heroTitle')}</h1>
      <p className="hero-en">{props.t('heroSubtitle')}</p>
      <button className="voice-button" type="button" onClick={props.onVoice} disabled={!props.voiceAvailable || props.listening}>
        <span aria-hidden="true">🎤</span>
        {props.listening ? props.t('voiceListening') : props.t('voicePrompt')}
      </button>
      {!props.voiceAvailable && <p className="hint">{props.t('voiceUnavailable')}</p>}
      <div className="or-row"><span>{props.t('or')}</span></div>
      <form className="search-form" onSubmit={submit}>
        <label htmlFor="destination-query" className="sr-only">{props.t('destinationInputLabel')}</label>
        <input
          ref={props.inputRef}
          id="destination-query"
          value={props.query}
          onChange={(event) => props.onQueryChange(event.target.value)}
          placeholder={props.t('destinationPlaceholder')}
          autoComplete="off"
          enterKeyHint="search"
        />
        <button type="submit" disabled={props.searching || props.query.trim().length < 2}>
          {props.searching ? props.t('searching') : props.t('search')}
        </button>
      </form>
      <p className="examples">{props.t('examples')}</p>
    </section>
  )
}
